module.exports = __webpack_public_path__ + "img/logo.1ac15f13.jpeg";